import 'babel-polyfill'
import 'whatwg-fetch'

import React from 'react'
import { render } from 'react-dom'
import { createStore, combineReducers, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { Router, browserHistory } from 'react-router'
import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import { reducer as reduxFormReducer } from 'redux-form'
import thunk from 'redux-thunk'
import promise from 'redux-promise'

import * as reducers from './reducers'
import { getRoutes } from './routes'

import createLogger from 'redux-logger'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'

injectTapEventPlugin()

function fbTrack ({ getState }) {
  return (next) => (action) => {
    let returnValue = next(action)

    window.fbq('track', 'PageView')
    return returnValue
  }
}

const middleware = [ thunk, promise, fbTrack ]
if (process.env.NODE_ENV !== 'production') {
   middleware.push(createLogger())
}

const store = createStore(combineReducers({
  ...reducers,
  form: reduxFormReducer,
  routing: routerReducer
}), applyMiddleware(...middleware))

const history = syncHistoryWithStore(browserHistory, store)

render(
  <Provider store={store}>
    <MuiThemeProvider>
      <Router history={history}>
        { getRoutes(store) }
      </Router>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/index.js